module.exports = __webpack_public_path__ + "img/logo_light.d6d7790b.webp";